import React, { useState } from 'react';
import {
  IconButton,
  MenuItem,
  Switch,
  Paper,
  TextField,
  Container,
  Button,
  Grid,
} from '@mui/material';
import { Close, FilterList } from '@mui/icons-material';
import { Controller, useForm } from 'react-hook-form';
import { useNavigate, useLocation } from 'react-router-dom';
import CustomDatePicker from 'app/components/CustomDatePicker/CustomDatePicker';
import { generateMongoQuery } from '../../../utils/utils';
import { translate } from 'translate';
import WithControllerAutoComplete from 'app/components/SmartAutoComplete/WithControllerAutoComplete';

const DataTableHeader = ({
  title,
  filtersOn,
  filters,
  onSubmit,
  handleAdd,
  showCreate = true,
  showExport,
  showImport,
  handleExport,
  createLabel,
  handleImport,
}) => {
  const [filtersOpen, setFiltersOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const { register, handleSubmit, control, getValues } = useForm();

  const onFormSubmit = (values) => {
    onSubmit(values);
    setFiltersOpen(false);
  };

  const handleClickCreate = () => {
    if (handleAdd) {
      handleAdd();
    } else {
      navigate(`${location.pathname}/add`);
    }
  };
  const handleClickExport = () => {
    handleExport(getValues());
  };
  const handleClickImport = () => {
    handleImport();
    // handleExport(generateMongoQuery(getValues()))
  };

  return (
    <div className="flex justify-between items-center px-6 mb-3">
      <div className="flex items-center justify-between min-w-[300px]">
        <div className="font-bold capitalize">{title}</div>

        {showCreate && (
          <Button variant="contained" color="primary" onClick={handleClickCreate}>
            {createLabel ? translate(createLabel) : translate('Create')}
          </Button>
        )}
        {showExport && (
          <Button onClick={handleClickExport} variant="contained" color="primary">
            {translate('Export CSV')}
          </Button>
        )}
      </div>
      {/* <ClickAwayListener onClickAway={() => setFiltersOpen(false)}> */}
      <div className="relative">
        <IconButton onClick={() => setFiltersOpen(true)}>
          <FilterList />
        </IconButton>

        {showImport && (
          <Button onClick={handleClickImport} variant="contained" color="primary">
            {translate('Import CSV')}
          </Button>
        )}

        {filtersOpen ? (
          <div className="absolute left-0 top-7 z-10  w-full md:min-w-[750px] min-w-[350px] ">
            <Container>
              <Paper className="bg-gray-100 p-3" elevation={3}>
                <div className="text font-bold flex justify-between items-center">
                  {translate('Filters')}
                  <IconButton onClick={() => setFiltersOpen(false)}>
                    <Close />
                  </IconButton>
                </div>
                <div>
                  <form className="">
                    <Grid container spacing={3} alignItems="center" className="max-md:flex-col">
                      {filtersOn.map((filter) => (
                        <Grid item>
                          <div key={filter.key} className="flex items-center">
                            <div className="ml-2 w-16">{translate(filter.name)}</div>
                            {generateFilter(filter, register, control)}
                          </div>
                        </Grid>
                      ))}
                    </Grid>
                  </form>
                  <br />
                  <div className="text-left">
                    <Button
                      onClick={handleSubmit(onFormSubmit)}
                      type="submit"
                      variant="contained"
                      color="primary"
                    >
                      {translate('Search')}
                    </Button>
                  </div>
                </div>
              </Paper>
            </Container>
          </div>
        ) : null}
      </div>
      {/* </ClickAwayListener> */}
    </div>
  );
};

const generateFilter = (filter, register, control) => {
  if (!filter.type) {
  }
  switch (filter.type) {
    case 'date':
      return (
        <Controller
          control={control}
          name={filter.key}
          render={({
            field: { onChange, onBlur, value, name, ref },
            fieldState: { invalid, isTouched, isDirty, error },
            formState,
          }) => <CustomDatePicker value={value} onBlur={onBlur} onChange={onChange} />}
        />
      );
    case 'select':
      return (
        <Controller
          control={control}
          name={filter.key}
          render={({
            field: { onChange, onBlur, value, name, ref },
            fieldState: { invalid, isTouched, isDirty, error },
            formState,
          }) => {
            // console.log(value)
            return (
              <TextField
                value={!value ? (filter.type === 'selectMultiple' ? [] : value) : value}
                onChange={onChange}
                select
                SelectProps={{
                  multiple: filter.type === 'selectMultiple',
                }}
              >
                {filter.items &&
                  filter.items.map((item, i) => (
                    <MenuItem key={i} value={item.value}>
                      {item.label}
                    </MenuItem>
                  ))}
              </TextField>
            );
          }}
        />
      );
    case 'switch':
      return (
        <Controller
          control={control}
          name={filter.key}
          render={({
            field: { onChange, onBlur, value, name, ref },
            fieldState: { invalid, isTouched, isDirty, error },
            formState,
          }) => {
            return (
              <Switch checked={!!value} onChange={onChange} value="checkedB" color="primary" />
            );
          }}
        />
      );
    case 'auto_complete':
      return (
        <React.Fragment>
          <WithControllerAutoComplete
            control={control}
            name={filter.key}
            label={translate(filter.label)}
            path={filter.options.path}
            render={filter.options.render}
            validation={filter.validation}
            defaultFilters={filter.defaultFilters}
            defaultValue={filter.defaultValue}
            disabled={filter.disabled}
          />
        </React.Fragment>
      );
    default:
      return (
        <TextField
          size="small"
          // sx={{ height: '10px' }}
          placeholder={translate(filter.name)}
          label={translate(filter.label)}
          {...register(filter.key)}
        />
      );
  }
};

export default DataTableHeader;
